import sanityClient from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';


export const client = sanityClient({
  projectId: 'njopbynd', 
  dataset: 'production',
  apiVersion: 'v2021-10-21',
  useCdn: true,
  token: 'skMvoskWEjYQsypC1PQjTnbbvnNBJua9XFvdSaLHXALFMg6RxhX7ZpnXLS1yLanTmFoYtVn3NyPgVteUp0cIS73cdwnZjX7ETQfzECM71KaY8Aj1hZ86cU54GXDT5u1b1taojjyMLTg2roD4PB81qOPekpYkS3bNIGB1K81GAR4ixx2HRZT2',
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);